<template>
<div id="loading-bg">
  <div class="loading">
    <div class="effect-1 effects"></div>
    <div class="effect-2 effects"></div>
    <div class="effect-3 effects"></div>
  </div>
</div>
</template>

<script>
import { SET_USER_DATA } from '@/store/mutations.types'
import { mapGetters } from 'vuex'
import AuthService from '@/common/auth.service'
export default {
  methods: {},
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ])
  },
  created() {
    if (this.isAuthenticated) {
      AuthService.confirmBranchEmployee({ 'invitation_token': this.$route.params.token }).then((response) => {
        this.$store.commit(SET_USER_DATA, {
          avatar: '',
          bank_account: null,
          bank_card: null,
          email: '',
          first_name: '',
          id: null,
          last_name: '',
          public_phrase: null,
          roles: ['EMPLOYEE'],
          userRole: ''
        })
        this.$router.push({ name: 'indexPage' })
      }).catch(({ response }) => {
        this.$vs.notify({
          title: 'Не удалось привязаться',
          text: response.data.error
        })
      })
    } else {
      this.$router.push({
        path: '/login',
        query: {
          redirect: this.$router.currentRoute.path
        }
      })
    }
  }
}
</script>
